module.exports = __webpack_public_path__ + "static/media/Battery-75.9f9e207a.svg";